var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.91117 0C4.543 0 4.24451 0.298481 4.24451 0.666666C4.24451 1.03485 4.543 1.33333 4.91117 1.33333H13.1334C13.8698 1.33333 14.4667 1.93029 14.4667 2.66666V16.2373C14.4667 16.6055 14.7652 16.9039 15.1334 16.9039C15.5016 16.9039 15.8 16.6055 15.8 16.2373V2.66666C15.8 1.1939 14.6061 0 13.1334 0H4.91117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 2.38477H0V18.0006C0 19.1051 0.89543 20.0006 2 20.0006H11.4C12.5046 20.0006 13.4 19.1051 13.4 18.0006V4.38476C13.4 3.2802 12.5046 2.38477 11.4 2.38477ZM1.33333 18.0006V3.7181H11.4C11.7682 3.7181 12.0667 4.01659 12.0667 4.38476V18.0006C12.0667 18.3687 11.7682 18.6672 11.4 18.6672H2C1.63181 18.6672 1.33333 18.3687 1.33333 18.0006Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.536b6d18ce786887cc1d7747dca27bff.svg";
export { ForwardRef as ReactComponent };